var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "task-config-container" }, [
    _c(
      "div",
      { staticClass: "list-container" },
      [
        _c(
          "el-form",
          {
            staticClass: "compact-search-form",
            attrs: { inline: true, model: _vm.searchForm },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c("el-input", {
                  staticStyle: { width: "220px" },
                  attrs: { placeholder: "种草官姓名", clearable: "" },
                  model: {
                    value: _vm.searchForm.keywords,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "keywords", $$v)
                    },
                    expression: "searchForm.keywords",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "状态", clearable: "" },
                    model: {
                      value: _vm.searchForm.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "status", $$v)
                      },
                      expression: "searchForm.status",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "正常", value: "1" } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "禁用", value: "0" } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { staticClass: "form-actions" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.fetchList } },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.addOffcer } },
                  [_vm._v("添加")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.download } },
                  [_vm._v("导出")]
                ),
                _vm._v(" "),
                _c(
                  "el-upload",
                  {
                    ref: "upload",
                    staticStyle: { display: "inline", margin: "0 10px" },
                    attrs: {
                      "show-file-list": false,
                      action: "#",
                      "http-request": function (opt) {
                        return _vm.handleCustomUpload(opt)
                      },
                      accept: ".xlsx,.xls",
                    },
                  },
                  [
                    _c("el-button", { attrs: { type: "primary" } }, [
                      _vm._v("导入"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              stripe: "",
              border: "",
              "element-loading-text": "数据加载中...",
              "element-loading-spinner": "el-icon-loading",
            },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "id", label: "ID", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "名称", align: "center", prop: "name" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "手机号", align: "center", prop: "phone" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "状态", prop: "", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.status == 1
                        ? _c("div", [_vm._v("正常")])
                        : _c("div", [_vm._v("禁用")]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "更新时间", prop: "updateTime", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "操作",
                align: "center",
                fixed: "right",
                width: "280",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.addOffcer(scope.row)
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.detailUserLog(scope.row)
                            },
                          },
                        },
                        [_vm._v("任务记录")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.openRewardDialog(scope.row)
                            },
                          },
                        },
                        [_vm._v("奖励记录")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              title: _vm.title,
              visible: _vm.addDialogVisible,
              width: "50%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.addDialogVisible = $event
              },
              close: _vm.resetAddForm,
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "addFormRef",
                attrs: {
                  model: _vm.addForm,
                  rules: _vm.addRules,
                  "label-width": "80px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "姓名", prop: "name" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.addForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "name", $$v)
                        },
                        expression: "addForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "手机号", prop: "phone" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.addForm.phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "phone", $$v)
                        },
                        expression: "addForm.phone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "状态", prop: "status" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.addForm.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "status", $$v)
                          },
                          expression: "addForm.status",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("正常"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: 0 } }, [
                          _vm._v("禁用"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        _vm.addDialogVisible = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.submitAdd } },
                  [_vm._v("确认")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                "current-page": _vm.searchForm.page,
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.searchForm.limit,
                total: _vm.searchForm.total,
              },
              on: {
                "current-change": _vm.handlePageChange,
                "size-change": _vm.handleSizeChange,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "奖励记录",
              visible: _vm.rewardDialogVisible,
              width: "60%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.rewardDialogVisible = $event
              },
            },
          },
          [
            _c(
              "div",
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.rewardLoading,
                        expression: "rewardLoading",
                      },
                    ],
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.rewardList, stripe: "", border: "" },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "id",
                        label: "ID",
                        width: "80",
                        align: "center",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "奖励类型", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.rewardType == 1
                                ? _c("div", [_vm._v("积分")])
                                : scope.row.rewardType == 2
                                ? _c("div", [_vm._v("优惠券")])
                                : _c("div", [_vm._v("其他")]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "奖励内容", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.rewardType == 1
                                ? _c("div", [
                                    _vm._v(_vm._s(scope.row.rewardValue)),
                                  ])
                                : scope.row.rewardType == 2
                                ? _c("div", [
                                    _vm._v(_vm._s(scope.row.couponId)),
                                  ])
                                : _c("div", [
                                    _vm._v(_vm._s(scope.row.rewardValue)),
                                  ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "status", label: "状态", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.status == 0
                                ? _c("div", [_vm._v("待发放")])
                                : scope.row.status == 1
                                ? _c("div", [_vm._v("发放中")])
                                : scope.row.status == 2
                                ? _c("div", [_vm._v("发放成功")])
                                : scope.row.status == 3
                                ? _c("div", [_vm._v("发放失败")])
                                : _c("div", [_vm._v(_vm._s(scope.row.status))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "createTime",
                        label: "时间",
                        align: "center",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "12px",
                      "text-align": "right",
                    },
                  },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        layout: "total, prev, pager, next, jumper",
                        "current-page": _vm.rewardSearch.page,
                        "page-size": _vm.rewardSearch.limit,
                        total: _vm.rewardSearch.total,
                      },
                      on: {
                        "current-change": _vm.handleRewardPageChange,
                        "size-change": _vm.handleRewardSizeChange,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }